import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        can('read', 'FABRICACAO')
        if (user.temPermissao(['admin_fabricacao'])) {
            can('manage', 'FABRICACAO')
        }
        if (user.temPermissao(['fabricacao'])) {
            can(['read', 'write', 'update', 'delete'], 'FABRICACAO')
        }
    }

    return build()
}